/*
 * HomePage is responsible for rendering the homepage.
 */

import { Component } from '@angular/core';
import { BasePage } from '@pages/base/base.page';

@Component({
  selector: 'app-home-page',
  templateUrl: 'home.page.html',
  styleUrls: ['home.page.less']
})
export class HomePage extends BasePage {}
